import React from 'react';

import Slider from 'react-slick';
import { Heading } from 'aplazame-design-system';
import Container from '../../componentsV2/Container';
import style from './style.module.scss';

const settings = {
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
};

function ScrollableSection(props) {
    React.useEffect(() => { }, []);
    const [currentSlide, setCurrentSlide] = React.useState(0);

    let wrapper = props.items.map((item, i) => {
        return (
            <div
                key={i}
                id={`scroll${i}`}
                className={`${style.wrapperPosAbsolute}`}
            >
                <div>
                    <img alt={item.image.alt} src={item.image.url} />
                    <Heading tag={'h3'} className={[style.headline].join()}>
                        {item.title}
                    </Heading>
                    <Heading tag={'h2'} className={[style.bigText].join()}>
                        {item.subtitle}
                    </Heading>
                </div>
            </div>
        );
    });

    if (props.items.length > 1) {
        wrapper = (
            <Slider {...settings} beforeChange={(slick, nextSlide) => setCurrentSlide(nextSlide)}>
                {props.items.map((item, i) => {
                    return (
                        <div
                            key={i}
                            id={`scroll${i}`}
                            className={`${style.wrapperPosAbsolute}`}
                        >
                            <div>
                                <img
                                    alt={item.image.alt}
                                    src={item.image.url}
                                />
                                <Heading
                                    tag={'h3'}
                                    className={[style.headline].join()}
                                >
                                    {item.title}
                                </Heading>
                                <Heading
                                    tag={'h2'}
                                    className={[style.bigText].join()}
                                >
                                    {item.subtitle}
                                </Heading>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        );
    }

    return (
        <section className={style.bgcolor}>
            <Container
                containerCpm={style.containerCpm}
                modifyPadding={`${style.modifyPadding}`}
            >
                <svg
                    className={style.svg}
                    viewBox="0 0 1438 926"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M654.982 -128.399C654.982 -171.816 652.624 -215.505 656.252 -258.56C657.613 -274.389 673.124 -289.042 682.286 -304.329C695.983 -290.489 716.03 -279.002 722.108 -262.359C748.776 -189.183 737.075 -112.298 736.803 -36.8612C736.712 -16.8712 727.459 4.11357 718.298 22.6563C712.492 34.4151 699.067 42.3749 688.998 52.0533C677.66 37.5809 658.066 24.0132 656.524 8.6363C652.17 -36.6803 654.982 -82.7204 654.982 -128.399Z"
                        fill="white"
                    />
                    <path
                        d="M1302.11 -144.589C1330.69 -128.941 1331.59 -109.855 1317.99 -86.0661C1267.64 2.30577 1185.46 61.8233 1117.34 134.095C1110.81 141.06 1095.38 139.703 1084.05 142.145C1081.51 127.673 1071.62 108.316 1077.51 99.4513C1122.05 33.3307 1163.05 -36.046 1224.01 -89.1415C1247.5 -109.493 1274.99 -125.503 1302.11 -144.589Z"
                        fill="white"
                    />
                    <path
                        d="M1456.75 432.115C1465.86 463.328 1452.97 477.463 1426.48 484.69C1328.21 511.681 1227.89 495.819 1128.47 498.889C1118.92 499.209 1108.97 487.376 1099.22 481.108C1107.69 469.084 1114.43 448.425 1124.88 446.314C1203.26 430.964 1281.45 410.817 1362.21 416.253C1393.25 418.428 1424.04 426.487 1456.75 432.115Z"
                        fill="white"
                    />
                    <path
                        d="M429.298 881.41C409.16 906.827 390.021 933.963 367.706 958.204C337.409 991.038 305.932 1023.06 272.551 1052.73C253.774 1069.46 230.643 1081.49 208.601 1094.24C204.7 1096.51 194.631 1093.25 190.821 1089.27C186.014 1084.3 180.208 1073.71 182.476 1069.37C199.167 1036.72 214.043 1002.07 236.721 973.853C264.478 939.209 297.859 908.546 331.422 879.058C359.996 854.003 397.64 843.42 429.298 881.41Z"
                        fill="white"
                    />
                    <path
                        d="M263.213 10.8074C226.566 -25.7354 189.285 -61.6449 153.998 -99.3635C148.193 -105.605 150.733 -119.625 149.463 -130.027C159.895 -129.755 172.866 -133.373 180.395 -128.579C250.786 -83.4437 318.909 -35.0518 375.966 26.5462C394.652 46.7171 409.528 71.2296 422.228 95.7422C426.582 104.064 420.414 127.943 416.332 128.667C403.36 130.838 384.855 130.204 376.056 122.245C336.96 86.7874 300.404 48.345 263.032 11.0787C263.123 10.8978 263.213 10.8978 263.213 10.8074Z"
                        fill="white"
                    />
                    <path
                        d="M145.05 500.601C93.2238 500.601 41.3975 501.496 -10.3007 499.705C-18.8315 499.385 -26.9774 487.681 -35.2517 481.221C-27.683 474.058 -21.0764 462.353 -12.3531 460.434C69.4275 442.717 151.914 428.902 235.939 432.228C263.456 433.315 291.357 440.159 317.72 448.538C326.699 451.352 339.271 472.587 336.898 475.976C329.265 486.658 315.731 499.258 303.865 499.833C251.076 502.328 197.967 500.92 145.114 500.92C145.05 500.728 145.114 500.665 145.05 500.601Z"
                        fill="white"
                    />
                    <path
                        d="M784.523 875.71C788.151 922.383 791.235 967.881 795.408 1013.29C799.218 1054.72 803.39 1096.14 809.105 1137.39C813.731 1170.86 798.764 1180.44 768.467 1175.74C760.757 1174.56 752.865 1174.75 744.701 1174.2C713.315 1092.34 726.378 1008.4 727.466 926.001C728.01 883.218 744.429 872.001 784.523 875.71Z"
                        fill="white"
                    />
                    <path
                        d="M1055.29 746.274C1095.38 773.5 1139.74 796.385 1174.48 829.219C1209.13 861.963 1252.22 888.375 1268.91 939.119C1277.8 965.983 1265.01 971.139 1248.5 965.802C1215.12 954.857 1180.1 942.827 1152.35 922.385C1118.6 897.511 1091.39 863.681 1061.73 833.38C1039.5 810.767 1039.32 783.631 1043.31 755.862C1047.3 752.696 1051.29 749.44 1055.29 746.274Z"
                        fill="white"
                    />
                </svg>

                <svg
                    className={style.svgMobile}
                    viewBox="0 0 375 615"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M160.579 64.1945C160.579 45.8843 159.587 27.4596 161.113 9.30199C161.685 2.6264 168.208 -3.55329 172.061 -10C177.821 -4.16363 186.251 0.681002 188.807 7.69991C200.022 38.5602 195.101 70.9845 194.987 102.798C194.949 111.229 191.058 120.079 187.205 127.899C184.764 132.858 179.118 136.215 174.884 140.296C170.115 134.193 161.876 128.471 161.227 121.986C159.396 102.875 160.579 83.4583 160.579 64.1945Z"
                        fill="white"
                    />
                    <path
                        d="M432.716 57.3672C444.732 63.9665 445.113 72.0153 439.391 82.0478C418.22 119.317 383.66 144.417 355.012 174.896C352.265 177.833 345.781 177.261 341.012 178.291C339.944 172.187 335.786 164.024 338.266 160.286C356.995 132.401 374.238 103.143 399.872 80.7509C409.752 72.1679 421.31 65.416 432.716 57.3672Z"
                        fill="white"
                    />
                    <path
                        d="M497.746 300.579C501.576 313.742 496.155 319.703 485.015 322.751C443.691 334.134 401.505 327.444 359.696 328.739C355.677 328.874 351.496 323.884 347.396 321.24C350.956 316.169 353.789 307.457 358.185 306.567C391.147 300.093 424.027 291.596 457.987 293.889C471.042 294.806 483.99 298.205 497.746 300.579Z"
                        fill="white"
                    />
                    <path
                        d="M65.6724 490.059C57.2039 500.778 49.1551 512.222 39.7711 522.445C27.0303 536.292 13.7935 549.796 -0.24427 562.308C-8.14054 569.365 -17.8678 574.439 -27.1373 579.817C-28.7776 580.771 -33.0119 579.398 -34.614 577.719C-36.6358 575.621 -39.0771 571.158 -38.1235 569.327C-31.1045 555.556 -24.8486 540.946 -15.312 529.045C-3.63927 514.435 10.3985 501.503 24.5127 489.067C36.5287 478.501 52.3594 474.038 65.6724 490.059Z"
                        fill="white"
                    />
                    <path
                        d="M-4.17245 122.901C-19.5835 107.49 -35.2616 92.346 -50.1005 76.439C-52.5419 73.807 -51.4738 67.8943 -52.0078 63.5075C-47.621 63.622 -42.1661 62.0961 -38.9999 64.1179C-9.39845 83.1529 19.2494 103.561 43.2434 129.539C51.1015 138.045 57.3574 148.383 62.6979 158.721C64.5289 162.23 61.935 172.301 60.2184 172.606C54.7635 173.521 46.9817 173.254 43.2815 169.897C26.8405 154.944 11.4675 138.732 -4.2487 123.016C-4.21056 122.939 -4.17245 122.939 -4.17245 122.901Z"
                        fill="white"
                    />
                    <path
                        d="M-53.863 329.461C-75.6575 329.461 -97.4521 329.839 -119.193 329.084C-122.78 328.949 -126.206 324.013 -129.685 321.288C-126.502 318.267 -123.724 313.331 -120.056 312.522C-85.6646 305.05 -50.9767 299.224 -15.6415 300.627C-4.06989 301.085 7.66352 303.971 18.7496 307.505C22.5259 308.692 27.8128 317.647 26.8147 319.077C23.6049 323.581 17.9134 328.895 12.9233 329.138C-9.27582 330.19 -31.6099 329.596 -53.836 329.596C-53.863 329.515 -53.836 329.488 -53.863 329.461Z"
                        fill="white"
                    />
                    <path
                        d="M215.054 487.655C216.58 507.339 217.877 526.526 219.632 545.676C221.234 563.147 222.989 580.618 225.392 598.012C227.337 612.126 221.043 616.17 208.302 614.186C205.06 613.691 201.741 613.767 198.308 613.538C185.109 579.015 190.603 543.616 191.06 508.865C191.289 490.821 198.194 486.091 215.054 487.655Z"
                        fill="white"
                    />
                    <path
                        d="M328.918 433.068C345.779 444.55 364.433 454.202 379.043 468.049C393.615 481.858 411.734 492.996 418.753 514.396C422.491 525.726 417.113 527.9 410.17 525.649C396.132 521.034 381.408 515.96 369.735 507.339C355.545 496.849 344.101 482.582 331.627 469.803C322.281 460.267 322.205 448.823 323.883 437.112C325.562 435.777 327.24 434.403 328.918 433.068Z"
                        fill="white"
                    />
                </svg>

                <div
                    id="sliderVertical"
                    style={{ position: 'relative' }}
                    className={`${props.items.length === 1 ? style.cursorNormal : ''
                        } ${style.wrapper}`}
                >
                    {props.items.length > 1 &&
                        <ul className={style.paginationContainer}>
                            {Array.from({ length: props.items.length }).map((_, i) => (
                                <li className={currentSlide === i ? style.paginationContainerVisible : ''} key={i} >{currentSlide + 1}/{props.items.length}</li>
                            ))}
                        </ul>
                    }
                    <Slider {...settings}>{wrapper}</Slider>
                </div>
            </Container>
        </section>
    );
}

export default ScrollableSection;
